import {
  Avatar,
  Card,
  CardHeader,
  Typography
} from '@mui/material';
import { DataGrid, GridCellEditStopReasons, koKR } from '@mui/x-data-grid';
import 'dayjs/locale/ko';
import moment from 'moment';
import { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import DateWidget from 'src/components/DateWidget';
import { getIcon } from 'src/utils/hex-to-rgba';
import CustomChip from '../../components/mui/chip';
import { apiService } from '../../api/axiosClient';
import CartToolbar from './CartToolbar';

const TableCart = ({id, reload, setReload}) => {  
  const [list, setList] = useState([]);
  const [pageSize, setPageSize] = useState(10)
  const [selected, setSelected] = useState([])

  useEffect(() => {
    const fetchData = async () => {
        try {
          const response = await apiService.get(`/carts/items/${id}`);
          const payload = response.data;
          setList(payload.list);
        } catch (error) {
          console.error(error);
        }
    }

    fetchData();
  }, [reload]);

  const handleStateChange = async (cartid, field, newValue) => {
    const updatedValue = newValue;

    setList((prevList) =>
      prevList.map((item) =>
        item.cartid === cartid ? { ...item, [field]: updatedValue } : item
      )
    );
  }

  const columns = [
    {
      minWidth: 300,
      field: 'name',
      headerName: '상품명',    
      renderCell: params => (
        <Fragment>
          <Avatar alt="image" src={getIcon(params.row.icon1)} variant="rounded" />
          <Link to={`/admin/product/item/${params.row.sku}`} >
            <Typography variant='body2' sx={{ ml: 4, color: 'text.primary' }}>
              {params.row.name}
            </Typography>
          </Link>
        </Fragment>
      )
    },
    {
      minWidth: 100,
      field: 'cat_id',
      headerName: 'Cat No',
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {params.row.cat_id}
        </Typography>
      )
    },    
    {
      minWidth: 200,
      field: 'spec_desc',
      headerName: '사양',
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {params.row.spec_desc}
        </Typography>
      )
    },
    {
      minWidth: 100,
      field: 'pd_cas',
      headerName: 'CAS',
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {params.row.pd_cas}
        </Typography>
      )
    },
    {
      minWidth: 100,
      field: 'pd_packing',
      headerName: '패킹',
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {params.row.pd_packing}
        </Typography>
      )
    },
    {
      minWidth: 100,
      field: 'qty',
      headerName: '수량*',
      editable: true,
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {params.row.qty}
        </Typography>
      )
    },
    {
      minWidth: 180,
      field: 'delivery_date',
      headerName: '납기일자*',
      renderCell: (params) => (
        <DateWidget 
          defaultValue={params.row.delivery_date}  
          onChange={newValue => {
            handleStateChange(params.row.cartid, 'delivery_date', newValue);
          }}
        />
      ),
    },
    {
      minWidth: 100,
      field: 'cprice',
      headerName: '단가*',
      editable: true,
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {params.row.cprice.toLocaleString('ko-KR')}
        </Typography>
      )
    },
    {
      field: 'sprice',
      minWidth: 100,
      headerName: '공급가',
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {(params.row.sprice).toLocaleString('ko-KR')}
        </Typography>
      )
    },
    {
      field: 'ctime',
      minWidth: 200,
      headerName: '주문시간',
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {moment(params.row.ctime).format("YYYY-MM-DD HH:mm")}
        </Typography>
      )
    }    
  ]

  return (    
    <Card>
      <CardHeader 
        title={<>주문번호 <CustomChip skin='light' size='small' label={id} color="info" /></>} 
        subheader={
          <Typography variant="body2" component="p">
            수량, 단가 항목을 더블클릭을 하면 수정이 가능합니다. 해당값 수정후 엔터키를 입력하세요. 
            이후 선택된 항목을 수정할 수 있습니다. <br/>항목 값을 변경후, 선택해서 수정할 수 있습니다.
          </Typography>
        }
      />
      <DataGrid
        getRowId={row => row.cartid}
        localeText={koKR.components.MuiDataGrid.defaultProps.localeText}
        autoHeight
        columns={columns}
        pageSize={pageSize}
        rowsPerPageOptions={[10, 25, 50]}
        rows={list}
        onPageSizeChange={newPageSize => setPageSize(newPageSize)}
        components={{ 
          Toolbar: CartToolbar
        }}
        componentsProps={{
          toolbar: {
            numSelected: selected.length,
            selected,
            setReload
          }
        }}
        checkboxSelection
        disableSelectionOnClick
        onSelectionModelChange={(ids) => {
          const selectedIDs = new Set(ids);
          const selectedRows = list.filter((row) =>
            selectedIDs.has(row.cartid),
          );

          setSelected(selectedRows)
        }}
        experimentalFeatures={{ newEditingApi: true }}
        onCellEditStop={(params, event) => {
          if (params.reason === GridCellEditStopReasons.enterKeyDown) {        
            if (event.target.value?.length === 0) {
              return
            }

            // change source data
            setList(list.map(item => {
              if (item.cartid == params.id) {
                  return { ...item, 
                    [params.field]: event.target.value
                  };
              }
              return item;
            }));

          }
        }}
      />
    </Card>
  )
}

export default TableCart
